import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function SolutionSection() {
  const benefits = ['Descargar tu mente en solo 5 minutos diarios.', 'Ordenar tus emociones con un diario guiado de 3 preguntas simples.', 'Sentirte más alivio, sin sumar tareas largas a tu rutina.'];
  return <section className="py-20 px-4 bg-[#FAF3EB]" data-id="element-113">
      <div className="container max-w-5xl mx-auto" data-id="element-114">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-115">
          <FadeIn direction="right" data-id="element-116">
            <div className="relative" data-id="element-117">
              <div className="absolute -inset-4 bg-[#C4703F]/10 rounded-full blur-2xl" data-id="element-118" />
              <h2 className="relative text-3xl md:text-4xl font-bold text-[#3D3229] mb-8 leading-tight" data-id="element-119">
                Con Reset Emocional en 5 Minutos vas a lograr:
              </h2>
              <div className="space-y-6 relative" data-id="element-120">
                {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-4" data-id="element-121">
                    <div className="mt-1 flex-shrink-0 w-6 h-6 rounded-full bg-[#8B9E7E] flex items-center justify-center text-white" data-id="element-122">
                      <CheckCircle2 className="w-4 h-4" data-id="element-123" />
                    </div>
                    <p className="text-lg text-[#3D3229]/90" data-id="element-124">{benefit}</p>
                  </div>)}
              </div>
            </div>
          </FadeIn>

          <FadeIn direction="left" delay={0.2} data-id="element-125">
            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-xl shadow-[#C4703F]/5 border border-[#C4703F]/10 relative overflow-hidden" data-id="element-126">
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#FAF3EB] rounded-bl-full -mr-8 -mt-8" data-id="element-127" />
              <div className="relative z-10" data-id="element-128">
                <h3 className="text-xl font-serif font-semibold text-[#C4703F] mb-4" data-id="element-129">
                  Tu nueva rutina
                </h3>
                <div className="space-y-4" data-id="element-130">
                  <div className="flex items-center gap-3 p-3 bg-[#FAF3EB] rounded-lg" data-id="element-131">
                    <span className="font-bold text-[#3D3229]" data-id="element-132">08:00</span>
                    <span className="text-[#3D3229]/70" data-id="element-133">
                      Audio de 3 minutos
                    </span>
                  </div>
                  <div className="flex items-center gap-3 p-3 bg-[#FAF3EB] rounded-lg" data-id="element-134">
                    <span className="font-bold text-[#3D3229]" data-id="element-135">08:03</span>
                    <span className="text-[#3D3229]/70" data-id="element-136">
                      Pregunta 1: ¿Cómo me siento?
                    </span>
                  </div>
                  <div className="flex items-center gap-3 p-3 bg-[#FAF3EB] rounded-lg" data-id="element-137">
                    <span className="font-bold text-[#3D3229]" data-id="element-138">08:05</span>
                    <span className="text-[#3D3229]/70" data-id="element-139">
                      Listo para el día ✨
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}